import React, { useEffect, useRef, useState } from 'react'
import { Breadcrumbs, InputField, SaveFixedButton } from '@reactiveonline/reactive_admin_shared-packages'
import CodeMirror from '@uiw/react-codemirror'
import { javascript } from "@codemirror/lang-javascript";
import { EditorView } from "@codemirror/view";
import { useCodeMirror } from "@uiw/react-codemirror";
import GlobalImports from '../shared/GlobalImports'

export default function Index({
  appProps, admin, breadcrumbs, settings, icon
}) {
  const [saveButtonRef, setSaveButtonRef] = useState(null)
  const [settingsState, setSettingsState] = useState(settings)

  const didMountRef = useRef(false)

  function handleSave() {
    const fd = new FormData()

    fd.append('settings', JSON.stringify(settingsState.map(el => ({ id: el.id, value: el.value }))))

    saveButtonRef.setSavingStatus()

    Rails.ajax({
      type: 'POST',
      url: appProps.saveSettingsPath,
      dataType: 'json',
      data: fd,
      success: res => {
        saveButtonRef.setSuccessStatus()
        setSettingsState(res.settings)
      },
      error: res => {
        saveButtonRef.setErrorStatusWithMessage(res.errors)
      }
    })
  }

  useEffect(() => {
    if (didMountRef.current) {
      saveButtonRef.setSaveableStatus()
    } else {
      didMountRef.current = true
    }
  }, [settingsState])

  const handleSettingChange = (id, value) => {
    const relevantSettingIndex = settings.findIndex(el => el.id === id)

    setSettingsState(prevState => [
      ...prevState.slice(0, relevantSettingIndex),
      {
        ...prevState[relevantSettingIndex],
        value: value
      },
      ...prevState.slice(relevantSettingIndex + 1),
    ])
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box items-center content-space-between'>
            <div className='page-header'>
              <i className={ `fa-light ${ icon }` }/>
              <h1 className='page-header-title'>
                { ReactiveCore.translations.settings }
              </h1>
            </div>
          </div>
          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <div className='card'>
        <div className='card-content'>
          <div className='card-body'>
            <div className='row'>
              { settingsState.map( (setting, index)=> {
                if (setting.key == 'home_promo_area' || setting.key == 'custom_scripts') {
                  return (
                    <div className='input-field col s12' key={ index }>
                      <label className='label'>
                        { setting.key ? setting.key.replace('_', ' ').toUpperCase() : ' ' }
                      </label>
                      <CodeMirror
                        value={ setting.value || '' }
                        height="500px"
                        extensions={[
                          javascript(),
                          EditorView.lineWrapping
                        ]}
                        onChange={(value, viewUpdate) => {
                          handleSettingChange(setting.id, value)
                        }}
                      />
                    </div>
                  )
                } else {
                  return (
                    <InputField
                      classes='col l6 m6 s12'
                      label={ setting.key ? setting.key.replace('_', ' ').toUpperCase() : ' ' }
                      key={ index }
                    >
                      <input
                        type='text'
                        value={ setting.value || '' }
                        onChange={ e => handleSettingChange(setting.id, e.target.value) }
                      />
                    </InputField>
                  )
                }
              })}
            </div>
          </div>
        </div>
      </div>

      <SaveFixedButton
        onSave={ handleSave }
        entity={ ReactiveCore.translations.settings }
        ref={ ref => setSaveButtonRef(ref) }
      />
      <GlobalImports appProps={ appProps } />
    </>
  )
}
